import * as React from 'react'

import { Box, CheckBox, Divider, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useNineGridBox } from 'modules/competencies/lib/ninegridboxContext'
import ninegridboxes from 'modules/competencies/store/collections/ninegridboxes'

import CompetencyChild from '../Child'

interface Props {
  competencyId: number
  key: number
  isXaxis: boolean
}

const CompetencyParent = ({ competencyId, isXaxis }: Props) => {
  const { onSelectCompetency, isChecked, filterChildren } = useNineGridBox()
  const ninegridbox = ninegridboxes.getCompetency(competencyId)
  const filteredChildrenIds = filterChildren(competencyId, isXaxis)

  const competencyName =
    filteredChildrenIds.length > 0
      ? `${ninegridbox?.competencyName} (${filteredChildrenIds?.length})`
      : ninegridbox?.competencyName

  return (
    <>
      <Divider />
      <Box
        paddingY="s12"
        paddingX="s24"
        flexDirection="row"
        gap="s16"
        background="grey000White"
        alignItems="center"
      >
        <CheckBox
          onClick={() => onSelectCompetency(competencyId, isXaxis)}
          checked={isChecked(competencyId)}
        />
        <Text.Normal color="grey1000">{competencyName}</Text.Normal>
      </Box>
      {filteredChildrenIds.length > 0 && (
        <Box>
          {filteredChildrenIds.map((competencyId) => (
            <CompetencyChild competencyId={competencyId} key={competencyId} isXaxis={isXaxis} />
          ))}
        </Box>
      )}
    </>
  )
}

export default observer(CompetencyParent)
